import React, { useEffect } from "react";
import {
    FaBolt,
    FaShieldAlt,
    FaRocket,
    FaMobileAlt,
    FaSyncAlt,
    FaLayerGroup
} from "react-icons/fa";
import "./KotlinFeatures.css";

const KotlinFeatures = () => {

    useEffect(() => {

        const cards = document.querySelectorAll(".kf-card");

        cards.forEach((card, i) => {

            card.style.opacity = "0";
            card.style.transform = "translateY(100px) scale(.8)";

            setTimeout(() => {

                card.style.transition = "1s ease";

                card.style.opacity = "1";

                card.style.transform = "translateY(0px) scale(1)";

            }, i * 150);

        });

    }, []);

    const features = [
        {
            icon: <FaBolt />,
            title: "Fast Compilation",
            desc: "Kotlin delivers faster development and efficient compilation speed.",
        },
        {
            icon: <FaShieldAlt />,
            title: "Null Safety",
            desc: "Reduce crashes with Kotlin’s powerful null safety system.",
        },
        {
            icon: <FaRocket />,
            title: "High Performance",
            desc: "Optimized Android applications with smooth performance.",
        },
        {
            icon: <FaMobileAlt />,
            title: "Modern UI",
            desc: "Create premium Android interfaces with modern frameworks.",
        },
        {
            icon: <FaSyncAlt />,
            title: "Java Interoperability",
            desc: "Use Kotlin seamlessly with Java and existing Android tools.",
        },
        {
            icon: <FaLayerGroup />,
            title: "Scalable Architecture",
            desc: "Perfect for startups and enterprise-scale Android solutions.",
        },
    ];

    return (
        <>
            <section
                style={{
                    position: "relative",
                    background: "#050505",
                    padding: "170px 24px",
                    overflow: "hidden",
                }}
            >

                {/* BACKGROUND */}
                <div className="kf-grid"></div>

                <div className="kf-glow kf-glow1"></div>
                <div className="kf-glow kf-glow2"></div>

                <div
                    style={{
                        maxWidth: "1400px",
                        margin: "0 auto",
                        position: "relative",
                        zIndex: 2,
                    }}
                >

                    {/* TOP */}
                    <div className="kf-top">

                        <div className="kf-badge">
                            🚀 Kotlin Features
                        </div>

                        <h2>
                            Powerful Features
                            <br />
                            of <span>Kotlin</span>
                        </h2>

                        <p>
                            Kotlin provides modern tools, secure architecture,
                            fast development workflow and scalable Android
                            application capabilities for businesses.
                        </p>

                    </div>

                    {/* ORBIT LAYOUT */}
                    <div className="kf-orbit-wrap">

                        {/* CENTER */}
                        <div className="kf-center">

                            <div className="kf-core">

                                <div className="kf-core-inner">
                                    K
                                </div>

                            </div>

                            <div className="kf-ring ring1"></div>
                            <div className="kf-ring ring2"></div>
                            <div className="kf-ring ring3"></div>

                        </div>

                        {/* FEATURE CARDS */}
                        {features.map((item, i) => (

                            <div
                                key={i}
                                className={`kf-card card-${i + 1}`}
                                onMouseEnter={(e) => {

                                    e.currentTarget.style.transform =
                                        "translateY(-16px) scale(1.04)";

                                    e.currentTarget.style.borderColor =
                                        "#E8212A";

                                    e.currentTarget.style.boxShadow =
                                        "0 35px 90px rgba(232,33,42,.18)";

                                }}
                                onMouseLeave={(e) => {

                                    e.currentTarget.style.transform =
                                        "translateY(0px) scale(1)";

                                    e.currentTarget.style.borderColor =
                                        "rgba(255,255,255,.08)";

                                    e.currentTarget.style.boxShadow =
                                        "none";
                                }}
                            >

                                <div className="kf-icon">
                                    {item.icon}
                                </div>

                                <h3>{item.title}</h3>

                                <p>{item.desc}</p>

                                <div className="kf-hover"></div>

                            </div>

                        ))}

                    </div>

                </div>

            </section>
        </>
    );
};

export default KotlinFeatures;